import { breadboxAPI, cached } from "@depmap/api";
import { capitalize, getDimensionTypeLabel } from "../../utils/misc";
import { SliceTypeNull } from "./useDimensionStateManager/types";

export async function fetchDimensionIdentifiers(
  dimensionTypeName: string,
  dataType?: string
) {
  const dimensionTypes = await cached(breadboxAPI).getDimensionTypes();
  const dimType = dimensionTypes.find((t) => t.name === dimensionTypeName);

  if (!dimType) {
    throw new Error(`Unrecognized dimension type "${dimensionTypeName}"!`);
  }

  return cached(breadboxAPI).getDimensionTypeIdentifiers(dimensionTypeName, {
    data_type: dataType,
    show_only_dimensions_in_datasets: true,
  });
}

export async function fetchDatasetIdentifiers(
  dimensionTypeName: string | SliceTypeNull,
  dataset_id: string
) {
  let isFeature = true;

  if (typeof dimensionTypeName === "string") {
    const dimensionTypes = await cached(breadboxAPI).getDimensionTypes();
    const dimType = dimensionTypes.find((t) => t.name === dimensionTypeName);

    if (!dimType) {
      throw new Error(`Unrecognized dimension type "${dimensionTypeName}"!`);
    }

    isFeature = dimType.axis === "feature";
  }

  const result = isFeature
    ? await cached(breadboxAPI, { persist: true }).getDatasetFeatures(
        dataset_id
      )
    : await cached(breadboxAPI, { persist: true }).getDatasetSamples(
        dataset_id
      );

  return result;
}

export async function fetchDimensionTypeDisplayName(
  dimensionTypeName: string | null
) {
  if (!dimensionTypeName) {
    return "";
  }

  const dimensionTypes = await cached(breadboxAPI).getDimensionTypes();
  const dimType = dimensionTypes.find((t) => t.name === dimensionTypeName);

  return (
    dimType?.display_name ||
    capitalize(getDimensionTypeLabel(dimensionTypeName))
  );
}
